import React from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";

class DefaultRedirect extends React.Component {
  componentDidMount() {
    this.props.redirectToCustomers();
  }
  render() {
    return "";
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = dispatch => ({
  redirectToCustomers: () => dispatch(push("/customers"))
});
export default connect(mapStateToProps, mapDispatchToProps)(DefaultRedirect);
